import styled from "styled-components";

export const Button = styled.button<{ selected?: boolean }>`
  padding: 0.5em;
  color: ${(props) => (props.selected ? "rgb(243,69,69)" : "#FFF")};
  background: ${(props) =>
    props.selected ? "rgb(243,69,69,0.2)" : "transparent"};
  border: 1px solid rgb(243, 69, 69);
  cursor: pointer;
  border-radius: 2rem;
  min-width: 50px;
  &:hover {
    background: ${(props) => (props.selected ? "#BF4F7433" : "#BF4F7433")};
  }
`;
